/* Ayudate · Preparación del comprobante de nota/nivel */

/* ------------------------------------------------------------------
   Igual que src/lib/foto.js, pero sin el recorte cuadrado: un
   comprobante (captura del expediente, certificado de idioma) tiene que
   quedar legible completo, no recortado a un círculo de avatar. Se
   reduce solo si excede el lado máximo, para no viajar pesado al
   servidor ni ocupar de más en la hoja de cálculo.
------------------------------------------------------------------- */
export const LADO_MAX_COMPROBANTE = 1600;
export const PESO_MAXIMO_COMPROBANTE = 12 * 1024 * 1024;   // 12 MB de entrada

export async function prepararComprobante(archivo) {
  if (!archivo.type.startsWith("image/"))
    throw new Error("Ese archivo no es una imagen.");
  if (archivo.size > PESO_MAXIMO_COMPROBANTE)
    throw new Error("La imagen pesa más de 12 MB. Pruebe con otra.");

  const url = URL.createObjectURL(archivo);
  try {
    const img = await new Promise((ok, mal) => {
      const i = new Image();
      i.onload = () => ok(i);
      i.onerror = () => mal(new Error("No pudimos leer la imagen."));
      i.src = url;
    });

    const escala = Math.min(1, LADO_MAX_COMPROBANTE / Math.max(img.width, img.height));
    const w = Math.round(img.width * escala);
    const h = Math.round(img.height * escala);

    const lienzo = document.createElement("canvas");
    lienzo.width = w;
    lienzo.height = h;
    const ctx = lienzo.getContext("2d");
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, 0, 0, w, h);

    const tipo = lienzo.toDataURL("image/webp", 0.85).startsWith("data:image/webp")
      ? "image/webp" : "image/jpeg";
    return lienzo.toDataURL(tipo, 0.85);
  } finally {
    URL.revokeObjectURL(url);
  }
}
